import sha256 from 'sha256';
import {PublisherSubscriber} from '@qphi/publisher-subscriber';
import { getSiteAccess } from '@imaios-js/utils';

const data = {};

export { default as sha256 } from 'sha256';

export function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

// https://stackoverflow.com/questions/54246477/how-to-convert-camelcase-to-snake-case-in-javascript
export function camelToSnakeCase(str) {
    let strSnaked = str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    const shouldRemoveFirstChar = str.charAt(0).match(/[A-Z]/);
    // if fisrt character is in uppercase, it will be prefixed by "_"
    // Example: "MyVar" -> "_my_var", that's why sometimes we have to remove first char
    if (shouldRemoveFirstChar) {
        strSnaked = strSnaked.substring(1);
    }

    return strSnaked;
}

export function getProperty(id, instance, s) {
    const tokens = id.split(separator);
    let node = instance;
    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];
        if (token.length === 0) {
            throw `Invalid instance id`;
        }
        if (typeof node[token] === 'undefined') {
            return null;
        }
        node = node[token];
    }
    return node;
}


export function store(key, value) {
    data[key] = value;
}

function clear(key) {
    delete data[key];
}

export function getSiteAccessLocale(defaultSiteAccess = 'en') {
    const siteAccess = getSiteAccess(defaultSiteAccess);

    switch (siteAccess) {
        case 'br':
            return 'pt';
        case 'cn':
            return 'zh';
        case 'jp':
            return 'ja';
        default:
            return siteAccess;
    }
}

export async function getJSON(url) {
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200) {
            return await response.json();
        }
        else {
            return null;
        }
    }
    catch (err) {
        console.error(err);
        return null;
    }
}


export function get(key) {
    return data[key] || null;
}

export const services = {};

export const pubsub = new PublisherSubscriber('imaios-main-pubsub');

export function fetch(url, params = { method: 'GET', _defaultPayload: true }) {
    // Force credential to same-origin, on some browser this property is set to "omit"
    // https://www.npmjs.com/package/whatwg-fetch#sending-cookies
    params.credentials = 'same-origin';

    // TODO uncomment and test IE11 before merge in imaios/dev
    // if (params._defaultPayload) {
    //     params.headers = new Headers();
    // }

    return window.fetch(url, params);
}

export function isSessionStorageAvailable() {
    // https://stackoverflow.com/questions/7192405/most-elegant-way-to-check-sessionstorage-support
    try {
        window.sessionStorage.setItem('test', 'test');
        window.sessionStorage.removeItem('test');
        return true;
    }
    catch (e) {
        return false;
    }
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
}

export function onPageLoaded(cb) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        cb();
    }
    else {
        document.addEventListener('DOMContentLoaded', () => {
            cb();
        });
    }
}

export function isIE() {
    const userAgent = window.navigator.userAgent;
    const Idx = userAgent.indexOf('MSIE');

    // If IE, return version number.
    let version = 0;
    if (Idx > 0) {
        version = parseInt(userAgent.substring(Idx + 5, userAgent.indexOf('.', Idx)));
    }
    else if (!!navigator.userAgent.match(/Trident\/7\./)) { // If IE 11 then look for Updated user agent string.
        version = 11;
    }

    return version !== 0;
}


window.sha256 = sha256;

window.imaios = {
    sha256,
    clamp,
    camelToSnakeCase,
    getProperty,
    store,
    clear,
    getSiteAccess,
    getJSON,
    get,
    services,
    pubsub,
    fetch,
    isSessionStorageAvailable,
    getCookie,
    onPageLoaded,
    isIE
};
